// extracted by mini-css-extract-plugin
export default {"enableSubtitlesTooltip":"DmbH6__enableSubtitlesTooltip"};